module.exports = __webpack_public_path__ + "static/media/MedicalReimbursement.5dd8a0b4.svg";